export const ERRORS_LIST_TO_NOT_SHOW_MODAL_ERROR = ['ELL-0006'];
